import { setCustomerSession } from "api";
import {
  signUpCustomerMutation,
  updateCustomerProfileMutation
} from "api/mutations";
import {
  getCurrentLocation,
  getCustomerByAuthToken,
  getTcpaDetails
} from "api/queries";
import {
  ICustomer,
  IGetCurrentLocationResponse,
  IGetCustomerDetailsInput,
  IGetTcpaDetailsResponse,
  ILoggedCustomer,
  ISignUpCustomerInput,
  ISignUpCustomerResponse,
  IUpdateCustomerProfileInput
} from "api/types";
import { ApolloClient } from "apollo-boost";
import { useState } from "react";
import { useMutation, useQuery } from "react-apollo";
import { handleApolloError } from "utils/errorHandling";

const api = {
  getCurrentLocation: () => {
    const { data, error, loading } = useQuery<IGetCurrentLocationResponse>(
      getCurrentLocation,
      { fetchPolicy: "network-only" }
    );
    if (error) {
      console.error(error.message);
    }
    return {
      currentLocation: data && data.me && data.me.location,
      loadingCurrentLocation: loading,
      error
    };
  },

  getTcpaDetails: () => {
    const { data, error, loading } = useQuery<{
      getTcpaDetails: IGetTcpaDetailsResponse;
    }>(getTcpaDetails, { fetchPolicy: "network-only" });
    if (error) {
      console.error(error.message);
    }
    return {
      tcpaDetails: data!.getTcpaDetails,
      loadingTcpaDetails: loading,
      error
    };
  },

  // TODO: move to CustomerProfileContainer
  getCustomerByAuthToken: (variables: IGetCustomerDetailsInput) => {
    const { data, error, loading } = useQuery<
      { getCustomerByAuthToken: ICustomer },
      IGetCustomerDetailsInput
    >(getCustomerByAuthToken, { variables, fetchPolicy: "network-only" });
    if (error) {
      console.error(error.message, variables);
    }
    return {
      customer: data!.getCustomerByAuthToken,
      error,
      loadingCustomer: loading
    };
  },

  setCustomerSession: (
    loggedCustomer: ILoggedCustomer,
    client: ApolloClient<{}>
  ) => {
    setCustomerSession(client, loggedCustomer);
  },
  signUpCustomer: (variables: ISignUpCustomerInput) => {
    const [signUpCustomer, { data, error, loading }] = useMutation<
      { signUpCustomer: ISignUpCustomerResponse },
      ISignUpCustomerInput
    >(signUpCustomerMutation, {
      variables
    });
    // TODO: compose loading, completed and error logic
    const completed = data && !loading && !error;
    return {
      signUpCustomer,
      data,
      error: handleApolloError("Error signing up.", error, variables),
      loading,
      completed
    };
  },

  // TODO: move to CustomerProfileContainer
  updateCustomerProfile: (variables: IUpdateCustomerProfileInput) => {
    const [updateCustomerProfile, { data, error, loading }] = useMutation<
      IUpdateCustomerProfileInput
    >(updateCustomerProfileMutation, {
      variables: { customer: variables }
    });
    // TODO: compose loading, completed and error logic
    const completed = data && !loading && !error;
    return {
      updateCustomerProfile,
      data,
      error: handleApolloError(
        "Error updating customer profile.",
        error,
        variables
      ),
      loading,
      completed
    };
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Onboarding.api.ts